import store from '@/store'

// 路由定位模式说明：
// locationMode: 'wait' 等定位请求完成后再进入页面
// locationMode: 'background' 页面直接进入，定位请求在后台执行
// 不配置 locationMode 时，不在路由守卫中处理定位
//
const LOCATION_MODE_WAIT = 'wait'
const LOCATION_MODE_BACKGROUND = 'background'

const fetchLocation = () => {
  return store
    .dispatch('location/getLocation')
    .catch(err => {
      console.error('获取定位失败:', err)
    })
}

export const locationHandle = async to => {
  const locationMode = to.meta?.locationMode
  // 不需要定位
  if (!locationMode) return
  let location = store.getters.location

  if (!location?.city) {
    if (locationMode === LOCATION_MODE_BACKGROUND) {
      fetchLocation()
      return null
    }

    if (locationMode === LOCATION_MODE_WAIT) {
      await fetchLocation()
    }

    location = store.getters.location
  }

  if (!to.path.startsWith('/movie')) return null
  if (store.getters.location.city_id) return null

  const movieResult = await store
    .dispatch(
      'location/fetchAndSetMovieCityId',
      location?.city
    )
    .catch(err => {
      console.error('获取电影城市ID失败:', err)
      return null
    })

  if (
    movieResult?.status ||
    store.getters.location.city_id
  ) {
    return null
  }

  return {
    path: '/location',
    query: {
      type: 'movie',
      reason: 'no_movie_city',
      redirect: to.fullPath
    },
    replace: true
  }
}
